import { render, staticRenderFns } from "./leftCol_SC.vue?vue&type=template&id=754761c8&scoped=true"
import script from "./leftCol_SC.vue?vue&type=script&lang=js"
export * from "./leftCol_SC.vue?vue&type=script&lang=js"
import style0 from "./leftCol_SC.vue?vue&type=style&index=0&id=754761c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754761c8",
  null
  
)

export default component.exports